module.exports = __webpack_public_path__ + "media/שוטרת.bd549a5c.mp3";